'use client';

import { TableCell } from '@repo/ui';
import type { JSX, ReactNode } from 'react';
import { useState } from 'react';

interface IPipelineStepCellProps {
  badge: ReactNode;
  renderDialog: (open: boolean, onOpenChange: (open: boolean) => void) => ReactNode;
}

export function PipelineStepCell({ badge, renderDialog }: IPipelineStepCellProps): JSX.Element {
  const [open, setOpen] = useState(false);
  return (
    <TableCell>
      <button
        type="button"
        className="cursor-pointer rounded transition hover:opacity-80"
        onClick={() => setOpen(true)}
      >
        {badge}
      </button>
      {renderDialog(open, setOpen)}
    </TableCell>
  );
}
